/**
 * The follow-up status of a list feedback (#717): a comment a CLIENT wrote on
 * one of its lists. The Invyo team moves it by hand; a reply in the thread
 * never changes it.
 *
 *  - `open`         what every client comment starts as (and every comment that
 *                   existed before #717);
 *  - `in_progress`  someone at Invyo is on it;
 *  - `resolved`     nothing left to do.
 *
 * A comment written by Invyo staff is a reply, not a feedback: its status is
 * null and it never shows up as a row of the List Feedbacks page.
 */

export const LIST_FEEDBACK_STATUSES = ['open', 'in_progress', 'resolved'] as const;

export type ListFeedbackStatus = (typeof LIST_FEEDBACK_STATUSES)[number];

/** The status a new comment is given: `open` for a client, none for Invyo staff. */
export function initialFeedbackStatus(authorIsAdmin: boolean): ListFeedbackStatus | null {
    return authorIsAdmin ? null : 'open';
}
